import FooterPatient from '../components/footer'

export default {
  FooterPatient
}



// WEBPACK FOOTER //
// ./src/app/auth/terms/policy/resources/components.js